export default __webpack_public_path__ + "static/media/RPL.37d622d4.png";